module.exports = __webpack_public_path__ + "static/img/Header_1920x380_cancer-cancer-monitoring.ecee155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headerimg/Header_1920x380_cancer-cancer-monitoring.jpg
// module id = +QQn
// module chunks = 0